// extracted by mini-css-extract-plugin
export default {"zoomModal":"l3-z","image":"m3-z","button":"n3-z","isOverlayShown":"o3-z"};